import styled from "styled-components";

export const SplReq = styled.div`
  padding: 2.5rem 3rem;
  border-top: 0.1rem #e5edf6 solid;
  h4 {
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 600;
    margin-bottom: 0.7rem;
    color: ${(p) => (p.theme ? p.theme.colors.black.base : "#141823")};
  }
  h5 {
    font-size: 1.2rem;
    line-height: 1.6rem;
    margin-bottom: 4rem;
    color: ${(p) => (p.theme ? p.theme.colors.grey.grey75 : "#4f525a")};
  }
  h6 {
    font-size: 1.4rem;
    line-height: 1.8rem;
    margin-bottom: 1.5rem;
    color: ${(p) => (p.theme ? p.theme.colors.black.dark : "#141823")};
  }
  .splReq__row {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 4.6rem;
  }
  .splReq__list {
    display: flex;
    > li {
      margin-right: 5rem;
      label {
        font-size: 1.4rem;
        line-height: 2rem;
        color: ${(p) => (p.theme ? p.theme.colors.black.dark : "#141823")};
      }
    }
  }
`;
